import {
  UPDATE_BUSINESS_SETTINGS_REQUEST,
  UPDATE_BUSINESS_SETTINGS_SUCCESS,
  UPDATE_BUSINESS_SETTINGS_FAILURE,
} from '../actions/update_business_settings'

export function updateBusinessSettings(
  state = {
    isFetching: false,
    settings: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case UPDATE_BUSINESS_SETTINGS_REQUEST:
      return {
        ...state,
        user: null,
        isFetching: true,
        errorMessage: null,
      }
    case UPDATE_BUSINESS_SETTINGS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        user: action.response,
      }
    case UPDATE_BUSINESS_SETTINGS_FAILURE:
      return {
        ...state,
        errors: null,
        user: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
